export class TrackingError extends Error {
    constructor(code, message) {
        super(message);
        // Object for storing properties of an event that's useful for debugging.
        this.debug = {};
        this.name = 'TrackingError';
        this.message = message;
        this.code = code;
    }
}
//# sourceMappingURL=tracking.js.map